import * as angular from 'angular';
import { ComponentDefinition } from '../../models';

export interface TabPaneHeader {
    text: string;
    icon: string;
}

class TabPaneController implements angular.IComponentController, angular.IOnChanges {

    selectedIndex: number;
    size: string;

    readonly headers: TabPaneHeader[];
    static $inject = [];


    $onInit() {
        this.selectedIndex = 0;
        this.computeSize();
    }

    $onChanges(changes: angular.IOnChangesObject) {
        this.computeSize();
    }

    select(index: number) {
        this.selectedIndex = index;
    }

    private computeSize() {
        const length = (this.headers ?? []).length ?? 1;
        this.size = `calc(${100 / length}% - ${(54) / length}px)`;
    }
}

export const wtTabPane: ComponentDefinition = {
    componentId: 'wtTabPane',
    controller: TabPaneController,
    controllerAs: 'vm',
    template: require('./tabPane.component.html'),
    transclude: true,
    bindings: {
        headers: '<',
        selectedIndex: '='
    }
};